import * as React from 'react';
import { useSelector } from 'react-redux';

import {
  selectIsDeniedBySanctions,
  selectIsBlockedOfferPublishBySanctions,
} from '../../../../../../selectors/publishTerms';

import { DeniedBySanctions } from '../../../ServiceError/components/DeniedBySanctions';
import { BlockOfferPublication } from '../../../ServiceError/components/BlockOfferPublication';
import { WithoutServicesScreen } from './WithoutServicesScreen';

export const WithoutServicesScreenContainer = () => {
  const isBlockedOfferPublishBySanctions = useSelector(selectIsBlockedOfferPublishBySanctions);
  const isDeniedBySanctions = useSelector(selectIsDeniedBySanctions);

  switch (true) {
    case isBlockedOfferPublishBySanctions:
      return <BlockOfferPublication />;

    case isDeniedBySanctions:
      return <DeniedBySanctions />;

    default:
      return <WithoutServicesScreen />;
  }
};
